<ptl-v3-filter-shell [title]="'translations.reviews.filter.status' | transloco" (applied)="applyFilter()" (deleted)="deleteFilter()">
  <ptl-select
    shell-controls
    class="v3-review-status-filter__is-select"
    [options]="isOptions"
    [ngModel]="statusIs"
    (selectionChange)="onStatusIsChange($event)"
  ></ptl-select>
  <div class="v3-review-status-filter__list">
    @for (status of statuses; track status.type) {
      <ptl-sg-checkbox
        class="v3-review-status-filter__item"
        [checked]="status.value"
        [ariaLabel]="status.label"
        (checkboxChange)="changeStatus(status.type)"
      >
        <span class="v3-review-status-filter__label">{{ status.label }}</span>
      </ptl-sg-checkbox>
    }
  </div>
</ptl-v3-filter-shell>
